import React, { useState, useEffect } from 'react';
import { Select } from 'semantic-ui-react';
import { local, local as localTesting, producaov2 } from "../../../services/apis";
import swal from "sweetalert";

function SelectStatus({statusProps,hashProps,changeStatusPedidoo,arr}){
    const [status,setStatus] = useState(false);
    const [loading,setLoading] = useState(true);

    useEffect(()=>{
        setLoading(true)
        setTimeout(() => {
            setLoading(false)
        }, 500);
        setStatus(statusProps)
    },[statusProps,hashProps])

    useEffect(()=>{
        setLoading(false)
    },[])

    function estornoAction(data){
        setLoading(true);
        producaov2.post(`/admin/pix/changestatusRefuned/${data.id_pedido}`)
        .then((res)=>{
            console.log(res.data)
            producaov2.post(`/admin/pix/estorno`,{e2eId:data.json,id_pedido:data.id_pedido})
            .then((res)=>{
                const newDataRefuned = res.data;
                console.log(newDataRefuned)
                setLoading(false)
                swal('Pedido estornado!','O pedido foi estornado com sucesso!','success')
            }).catch((error)=>{
                setLoading(false);
                swal('Erro no estorno','Houve um erro ao estornar o pedido','error')
            })
        }).catch((error)=>{
            setLoading(false);
            swal('Erro no estorno','Houve um erro ao alterar os dados do pedido','error')
        })
      }

      function changeStatusPedido(option,data){
        if (window.confirm("Tem certeza que deseja mudar o pedido para o status selecionado?")) {
          switch (option) {
            case "2":
              estornoAction(data)
              break;
            case "1":
              alert("Só é possível estornar pedidos")
              break;
            case "3":
              alert("Só é possível estornar pedidos")
              break;

            default:
              break;
          }
        }
      }

    return (
        loading
            ?<div class="ui segment">
            <p></p>
            <div class="ui active dimmer">
                <div class="ui small loader"></div>
            </div>
            </div>
            :<Select
                style={{pointerEvents:!status === 0?'none':'auto'}}
                disabled={!status === 0}
                defaultValue={ status == 0?"1":status==70?"3":"2"}
                onChange={(e, f) => changeStatusPedido(f.value,arr)}
                options={
                [
                { key: "1", value: "1", text: "Pago" },
                { key: "2", value: "2", text: "Estornado" },
                { key: "3", value: "3", text: "Não pago" },
                ]
            }></Select>

    )
}

export default SelectStatus;
